export default {
    states: {
        confirm: "confirm",
        loading: "loading",
    },
    text: {
        confirm: {
            warning:
                "You must be physically at the store prior to performing this test. Ensure Store Management has " +
                "been notified prior to performing a dim test. Not doing so may cause disruptions to customers " +
                "and personnel.",
            testDuration: "(2 minutes)",
            buttons: {
                confirm: "Test",
                deny: "Cancel",
            },
        },
        loading: "Starting dim-test...",
    },
};
